import PropTypes from 'prop-types'
import React from 'react'
import { Segment } from 'semantic-ui-react'

import {
  ContentContainer,
  ErrorMessagePrimary,
  ErrorMessageSecondary,
  MessageContainer,
  ReturnLoginButton,
} from './KindeCallback.styled'
import { isDrayNow } from '../../../../lib/config/multitenancy'
import { AuthLayoutView } from '../AuthLayout'

function KindeCallbackView({
  isLoading,
  checkInProgress,
  errorMessage,
  countdown,
  handleReturnToLogin,
  handleSignInDifferentAccount,
}) {
  return (
    <>
      {(isLoading || checkInProgress) && !errorMessage ? (
        <Segment style={{ height: '100vh' }} loading />
      ) : (
        <AuthLayoutView isDrayNow={isDrayNow}>
          <ContentContainer>
            <MessageContainer
              $isDrayNow={isDrayNow}
              $isWarning={errorMessage.includes('mobile app')}
            >
              <ErrorMessagePrimary
                $isDrayNow={isDrayNow}
                $isWarning={errorMessage.includes('mobile app')}
              >
                {errorMessage}
              </ErrorMessagePrimary>
              <ErrorMessageSecondary
                $isDrayNow={isDrayNow}
                $isWarning={errorMessage.includes('mobile app')}
              >
                You will be automatically redirected to login screen.
              </ErrorMessageSecondary>
            </MessageContainer>
            {errorMessage && (
              <>
                <ReturnLoginButton
                  primary
                  icon='user'
                  content='Sign in with a different account'
                  onClick={handleSignInDifferentAccount}
                />
                <ReturnLoginButton
                  basic
                  icon='arrow left'
                  content={`Return to Login Page (${countdown})`}
                  onClick={handleReturnToLogin}
                />
              </>
            )}
          </ContentContainer>
        </AuthLayoutView>
      )}
    </>
  )
}

KindeCallbackView.propTypes = {
  isLoading: PropTypes.bool,
  checkInProgress: PropTypes.bool,
  errorMessage: PropTypes.string,
  countdown: PropTypes.number,
  handleReturnToLogin: PropTypes.func.isRequired,
  handleSignInDifferentAccount: PropTypes.func.isRequired,
}

export { KindeCallbackView }
